import { Component, forwardRef, OnInit } from '@angular/core';
import { DynamicComponentBase, IDynamicComponentConfig } from '../../../dynamic-component';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-d-textarea',
  templateUrl: './d-textarea.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DTextareaComponent),
      multi: true
    }
  ]
})
export class DTextareaComponent extends DynamicComponentBase {
  static KEY = 'd-textarea';

  constructor() {
    super();
  }

  configChange(config: IDynamicComponentConfig) {
    if (typeof config.autosize !== 'string' && typeof config.autosize !== 'boolean') {
      config.autoszie = true;
    }
  }
}
